import React from "react";
import { DocProps, DocMap } from "../../Language";
import { PreInfoISKSV as SV } from "./PreInfoISKSV";
import "../../Documents.css";

const docsMap: DocMap = { SV };

export const PreInfoISK: React.FC<DocProps> = props =>
  React.createElement(docsMap[props.language], null);
